import { render, staticRenderFns } from "./ContentFeedVideoGalleryItem.vue?vue&type=template&id=2de361de&scoped=true&"
import script from "./ContentFeedVideoGalleryItem.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedVideoGalleryItem.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedVideoGalleryItem.vue?vue&type=style&index=0&id=2de361de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de361de",
  null
  
)

export default component.exports